import { render, staticRenderFns } from "./Bayonnoma.vue?vue&type=template&id=c01b4ec2"
import script from "./Bayonnoma.vue?vue&type=script&lang=js"
export * from "./Bayonnoma.vue?vue&type=script&lang=js"
import style0 from "./Bayonnoma.vue?vue&type=style&index=0&id=c01b4ec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports